export enum DeviceType {
  ENVIROQ = "ENVIROQ",
  THERMALQ = "THERMALQ",
  HOTDROP = "HOTDROP",
  AIRWITS = "AIRWITS",
  AIRWITS_IAQ = "AIRWITS_IAQ",
  AIRWITS_CO2 = "AIRWITS_CO2",
  AIRWITS_CO2_PLUS = "AIRWITS_CO2_PLUS",
  AIRWITS_PM = "AIRWITS_PM",
  DETECTIFY = "DETECTIFY",
  PCS_FLOWMETER = "PCS_FLOWMETER",
  ADEUNIS_PULSE_WATER = "ADEUNIS_PULSE_WATER",
  ADEUNIS_PULSE = "ADEUNIS_PULSE",
  ADEUNIS_PULSE_GAS = "ADEUNIS_PULSE_GAS",
  FLEXSENSE = "FLEXSENSE",
  FLEXSENSE_PROBE = "FLEXSENSE_PROBE",
  VOLTDROP = "VOLTDROP",
  VOLTDROP_PHASE = "VOLTDROP_PHASE",
  ROOM_RADAR = "ROOM_RADAR",
  ROOM_RADAR_LINE = "ROOM_RADAR_LINE",
  ROOM_RADAR_REGION = "ROOM_RADAR_REGION",
  GATEWAY = "GATEWAY",
  MOKO_LW005 = "MOKO_LW005",
  EMS2DESK = "EMS2DESK",
  ERS2EYE = "ERS2EYE",
  SOLAR_CSV = "SOLAR_CSV",
  MILESIGHT_CT = "MILESIGHT_CT",
  MILESIGHT_CT_PHASE = "MILESIGHT_CT_PHASE",
  MILESIGHT_CT_THREE_PHASE = "MILESIGHT_CT_THREE_PHASE",
  /** Milesight CTH01 Smart Power Monitor Hub; its circuits are the virtual children below */
  MILESIGHT_CTH01 = "MILESIGHT_CTH01",
  MILESIGHT_CTH01_CIRCUIT = "MILESIGHT_CTH01_CIRCUIT",
  MILESIGHT_CTH01_THREE_PHASE_CIRCUIT = "MILESIGHT_CTH01_THREE_PHASE_CIRCUIT",
  MILESIGHT_CTH01_PHASE = "MILESIGHT_CTH01_PHASE",
  KROHNE_AFE400_FLOWMETER = "KROHNE_AFE400_FLOWMETER",
  MILESIGHT_EM300 = "MILESIGHT_EM300",
  MILESIGHT_EM320 = "MILESIGHT_EM320",
  PFLOW_E3R_FLOWMETER = "PFLOW_E3R_FLOWMETER",
  MILESIGHT_AM103 = "MILESIGHT_AM103",
  MILESIGHT_AM102 = "MILESIGHT_AM102",
  MILESIGHT_AM308 = "MILESIGHT_AM308",
  MILESIGHT_AM319 = "MILESIGHT_AM319",
  MILESIGHT_WS202 = "MILESIGHT_WS202",
  MILESIGHT_WS203 = "MILESIGHT_WS203",
  MILESIGHT_WS523 = "MILESIGHT_WS523",
  MILESIGHT_VS321 = "MILESIGHT_VS321",
  MILESIGHT_VS351 = "MILESIGHT_VS351",
  MILESIGHT_VS34X = "MILESIGHT_VS34X",
  MILESIGHT_VS330 = "MILESIGHT_VS330",
  MILESIGHT_VS121 = "MILESIGHT_VS121",
  MILESIGHT_VS360 = "MILESIGHT_VS360",
  UNKNOWN = "UNKNOWN",
  EASTRON_POWER = "EASTRON_POWER",
  VICTRON_ENERGY_INVERTER = "VICTRON_ENERGY_INVERTER",
  ELSYS_ERS = "ELSYS_ERS",
  ELSYS_ERS_LITE = "ELSYS_ERS_LITE",
  ELSYS_ERS_CO2 = "ELSYS_ERS_CO2",
  ELSYS_ERS_CO2_LITE = "ELSYS_ERS_CO2_LITE",
  ELSYS_ERS_VOC = "ELSYS_ERS_VOC",
  ELSYS_ERS_EYE = "ELSYS_ERS_EYE",
  ELSYS_ERS_SOUND = "ELSYS_ERS_SOUND",
  QUANDIFY_CUBICMETER = "QUANDIFY_CUBICMETER",
  BOVE_BECO = "BOVE_BECO",
  GENUS_INTELLILOG = "GENUS_INTELLILOG",
}

export const ACCEPTED_DEVICE_TYPES = new Set([
  DeviceType.PCS_FLOWMETER,
  DeviceType.ENVIROQ,
  DeviceType.THERMALQ,
  DeviceType.AIRWITS,
  DeviceType.AIRWITS_IAQ,
  DeviceType.AIRWITS_CO2,
  DeviceType.AIRWITS_CO2_PLUS,
  DeviceType.AIRWITS_PM,
  DeviceType.DETECTIFY,
  DeviceType.HOTDROP,
  DeviceType.GATEWAY,
  DeviceType.FLEXSENSE,
  DeviceType.FLEXSENSE_PROBE,
  DeviceType.VOLTDROP,
  DeviceType.VOLTDROP_PHASE,
  DeviceType.ROOM_RADAR,
  DeviceType.ROOM_RADAR_LINE,
  DeviceType.ROOM_RADAR_REGION,
  DeviceType.ADEUNIS_PULSE,
  DeviceType.ADEUNIS_PULSE_WATER,
  DeviceType.EMS2DESK,
  DeviceType.ERS2EYE,
  DeviceType.MILESIGHT_CT,
  DeviceType.MILESIGHT_CT_PHASE,
  DeviceType.MILESIGHT_CT_THREE_PHASE,
  DeviceType.MILESIGHT_CTH01,
  DeviceType.MILESIGHT_CTH01_CIRCUIT,
  DeviceType.MILESIGHT_CTH01_THREE_PHASE_CIRCUIT,
  DeviceType.MILESIGHT_CTH01_PHASE,
  DeviceType.KROHNE_AFE400_FLOWMETER,
  DeviceType.MILESIGHT_EM300,
  DeviceType.MILESIGHT_EM320,
  DeviceType.MILESIGHT_AM103,
  DeviceType.MILESIGHT_AM102,
  DeviceType.MILESIGHT_AM308,
  DeviceType.MILESIGHT_AM319,
  DeviceType.MILESIGHT_WS202,
  DeviceType.MILESIGHT_WS203,
  DeviceType.MILESIGHT_WS523,
  DeviceType.MILESIGHT_VS34X,
  DeviceType.MILESIGHT_VS330,
  DeviceType.MILESIGHT_VS121,
  DeviceType.MILESIGHT_VS321,
  DeviceType.MILESIGHT_VS360,
  DeviceType.MOKO_LW005,
  DeviceType.MILESIGHT_VS351,
  DeviceType.EASTRON_POWER,
  DeviceType.VICTRON_ENERGY_INVERTER,
  DeviceType.SOLAR_CSV,
  DeviceType.PFLOW_E3R_FLOWMETER,
  DeviceType.ELSYS_ERS_LITE,
  DeviceType.ELSYS_ERS_CO2,
  DeviceType.ELSYS_ERS_CO2_LITE,
  DeviceType.ELSYS_ERS_VOC,
  DeviceType.ELSYS_ERS_EYE,
  DeviceType.ELSYS_ERS_SOUND,
  DeviceType.QUANDIFY_CUBICMETER,
  DeviceType.BOVE_BECO,
  DeviceType.GENUS_INTELLILOG,
]);

export const SolarDeviceTypes = new Set([DeviceType.SOLAR_CSV, DeviceType.VICTRON_ENERGY_INVERTER]);

export const WaterDeviceTypes = new Set([
	DeviceType.PCS_FLOWMETER,
	DeviceType.KROHNE_AFE400_FLOWMETER,
  DeviceType.PFLOW_E3R_FLOWMETER,
]);

export const VolumetricWaterDeviceTypes = new Set([
  DeviceType.QUANDIFY_CUBICMETER,
  DeviceType.BOVE_BECO,
]);

export const EnergyDeviceTypes = new Set([
  DeviceType.HOTDROP,
  DeviceType.VOLTDROP,
  DeviceType.VOLTDROP_PHASE,
  DeviceType.MILESIGHT_CT,
  DeviceType.MILESIGHT_CT_PHASE,
  DeviceType.MILESIGHT_CT_THREE_PHASE,
  // CTH01 circuits and phases carry power; the hub itself only reports temperature and unbalance
  DeviceType.MILESIGHT_CTH01_CIRCUIT,
  DeviceType.MILESIGHT_CTH01_THREE_PHASE_CIRCUIT,
  DeviceType.MILESIGHT_CTH01_PHASE,
  DeviceType.MILESIGHT_WS523,
  DeviceType.MOKO_LW005,
  DeviceType.EASTRON_POWER,
  DeviceType.VICTRON_ENERGY_INVERTER,
  ...SolarDeviceTypes,
]);

export const AirDeviceTypes = new Set([
  DeviceType.ENVIROQ,
  DeviceType.AIRWITS,
  DeviceType.AIRWITS_CO2,
  DeviceType.AIRWITS_CO2_PLUS,
  DeviceType.AIRWITS_IAQ,
  DeviceType.AIRWITS_PM,
  DeviceType.MILESIGHT_AM308,
  DeviceType.MILESIGHT_AM319,
]);

export const ThermalDeviceTypes = new Set([DeviceType.ENVIROQ, DeviceType.THERMALQ]);

export const EnvironmentalDeviceTypes = new Set([...ThermalDeviceTypes, ...AirDeviceTypes]);

export const PulseMeterDeviceTypes = new Set([
  DeviceType.ADEUNIS_PULSE,
  DeviceType.MILESIGHT_EM300,
  DeviceType.ADEUNIS_PULSE_WATER,
  DeviceType.ADEUNIS_PULSE_GAS,
  DeviceType.GENUS_INTELLILOG,
]);

export const RoomRadarDeviceTypes = new Set([
  DeviceType.ROOM_RADAR,
  DeviceType.ROOM_RADAR_LINE,
  DeviceType.ROOM_RADAR_REGION,
  DeviceType.MILESIGHT_VS351,
  DeviceType.MILESIGHT_VS121,
  DeviceType.MILESIGHT_VS321,
  DeviceType.MILESIGHT_VS360,
]);

export const OccupancyLineDeviceTypes = new Set([
  DeviceType.ROOM_RADAR_LINE,
  DeviceType.MILESIGHT_VS351,
  DeviceType.MILESIGHT_VS121,
]);

export const OccupancyDeviceTypes = new Set([
  ...RoomRadarDeviceTypes,
  ...OccupancyLineDeviceTypes,
  DeviceType.DETECTIFY,
  DeviceType.MILESIGHT_VS34X,
  DeviceType.MILESIGHT_VS330,
  DeviceType.MILESIGHT_WS202,
  DeviceType.MILESIGHT_WS203,
]);
